export type ExportType =
  | 'GroupByKeyword'
  | 'GroupByProduct'
  | 'GroupByCategory'
  | 'GroupBySubcategory'
  | 'GroupByBrand'
  | 'GroupByBrandSubcategory'
  | 'GroupByBrandKeyword'
  | 'GroupBySubcategoryKeyword'
  | 'GroupByProductKeyword'
  | 'GroupByContentScoreProduct'
  | 'GroupByReviewsRatingBrand'
  | 'GroupByReviewsRatingCategory'
  | 'GroupByReviewsRatingSubcategory'
  | 'GroupByReviewsRatingProduct'
  | 'GroupByPromotionProduct';

export const EXPORT_TYPES: { [key: string]: ExportType } = {
  PRODUCT: 'GroupByProduct',
  BRAND: 'GroupByBrand',
  CATEGORY: 'GroupByCategory',
  SUBCATEGORY: 'GroupBySubcategory',
  BRAND_SUBCATEGORY: 'GroupByBrandSubcategory',
  KEYWORD: 'GroupByKeyword',
  BRAND_KEYWORD: 'GroupByBrandKeyword',
  SUBCATEGORY_KEYWORD: 'GroupBySubcategoryKeyword',
  PRODUCT_KEYWORD: 'GroupByProductKeyword',
  GROUP_BY_CONTENT_SCORE_PRODUCT: 'GroupByContentScoreProduct',
  GROUP_BY_REVIEWS_RATING_BRAND: 'GroupByReviewsRatingBrand',
  GROUP_BY_REVIEWS_RATING_CATEGORY: 'GroupByReviewsRatingCategory',
  GROUP_BY_REVIEWS_RATING_SUBCATEGORY: 'GroupByReviewsRatingSubcategory',
  GROUP_BY_REVIEWS_RATING_PRODUCT: 'GroupByReviewsRatingProduct',
  GROUP_BY_PROMOTIONS_PRODUCT: 'GroupByPromotionProduct'
};

export const EXPORT_TYPES_DROPDOWN_OPTIONS = {
  [EXPORT_TYPES.PRODUCT]: { id: EXPORT_TYPES.PRODUCT, label: 'Product', fieldName: 'product' },
  [EXPORT_TYPES.BRAND]: { id: EXPORT_TYPES.BRAND, label: 'Brand', fieldName: 'brand' },
  [EXPORT_TYPES.CATEGORY]: { id: EXPORT_TYPES.CATEGORY, label: 'Category', fieldName: 'category' },
  [EXPORT_TYPES.SUBCATEGORY]: { id: EXPORT_TYPES.SUBCATEGORY, label: 'Subcategory', fieldName: 'subcategory' },
  [EXPORT_TYPES.BRAND_SUBCATEGORY]: {
    id: EXPORT_TYPES.BRAND_SUBCATEGORY,
    label: 'Brand & Subcategory',
    fieldName: 'brandAndSubcategory',
    fileName: 'Brand_subcategory'
  },
  [EXPORT_TYPES.KEYWORD]: { id: EXPORT_TYPES.KEYWORD, label: 'Keyword', fieldName: 'keyword' },
  [EXPORT_TYPES.BRAND_KEYWORD]: {
    id: EXPORT_TYPES.BRAND_KEYWORD,
    label: 'Brand & Keyword',
    fieldName: 'brandAndKeyword',
    fileName: 'Brand_keyword'
  },
  [EXPORT_TYPES.SUBCATEGORY_KEYWORD]: {
    id: EXPORT_TYPES.SUBCATEGORY_KEYWORD,
    label: 'Subcategory & Keyword',
    fieldName: 'subcategoryAndKeyword',
    fileName: 'Subcategory_keyword'
  },
  [EXPORT_TYPES.PRODUCT_KEYWORD]: {
    id: EXPORT_TYPES.PRODUCT_KEYWORD,
    label: 'Product & Keyword',
    fieldName: 'productAndKeyword',
    fileName: 'Product_keyword'
  },
  [EXPORT_TYPES.GROUP_BY_CONTENT_SCORE_PRODUCT]: {
    id: EXPORT_TYPES.GROUP_BY_CONTENT_SCORE_PRODUCT,
    label: 'Product',
    fieldName: null
  },
  [EXPORT_TYPES.GROUP_BY_REVIEWS_RATING_PRODUCT]: {
    id: EXPORT_TYPES.GROUP_BY_REVIEWS_RATING_PRODUCT,
    label: 'Product',
    fieldName: 'product'
  },
  [EXPORT_TYPES.GROUP_BY_REVIEWS_RATING_BRAND]: {
    id: EXPORT_TYPES.GROUP_BY_REVIEWS_RATING_BRAND,
    label: 'Brand',
    fieldName: 'brand'
  },
  [EXPORT_TYPES.GROUP_BY_REVIEWS_RATING_CATEGORY]: {
    id: EXPORT_TYPES.GROUP_BY_REVIEWS_RATING_CATEGORY,
    label: 'Category',
    fieldName: 'category'
  },
  [EXPORT_TYPES.GROUP_BY_REVIEWS_RATING_SUBCATEGORY]: {
    id: EXPORT_TYPES.GROUP_BY_REVIEWS_RATING_SUBCATEGORY,
    label: 'Subcategory',
    fieldName: 'subcategory'
  },
  [EXPORT_TYPES.GROUP_BY_REVIEWS_RATING_BRAND_SUBCATEGORY]: {
    id: EXPORT_TYPES.GROUP_BY_REVIEWS_RATING_BRAND_SUBCATEGORY,
    label: 'Brand & Subcategory',
    fieldName: 'brandAndSubcategory',
    fileName: 'Brand_subcategory'
  },
  [EXPORT_TYPES.GROUP_BY_PROMOTIONS_PRODUCT]: {
    id: EXPORT_TYPES.GROUP_BY_PROMOTIONS_PRODUCT,
    label: 'Product',
    fieldName: null
  }
};
